module.exports = __webpack_public_path__ + "img/ford-logo.63caea21.png";